module.exports = __webpack_public_path__ + "img/trash-can.ef6420dd.svg";